import React, { useContext } from "react";
import { FormLayout, Text, InlineStack, BlockStack } from "@shopify/polaris";
import { withErrorBoundary } from "lib/hoc";
import ConsignmentShip from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";
import DropShip from "app/setup/modules/operator/features/_fulfillment/dropShip/dropShip";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";
import { HybridDropshipWrapper } from "asset/styles/globalStyle";

const HybridDropShip = () => {
  const { cms } = useContext(FulfillmentContext);
  return (
    <HybridDropshipWrapper>
      <DropShip />
      <BlockStack ga="10">
        {/* <br /> */}
        <FormLayout>
          <InlineStack>
            <Text variant="headingMd" as="h2">
              {cms("title")}
            </Text>
            {/* 
            <Link onClick={() => learnMore(cms("title"), cms("title"))}>{cms("common.learnMore")}</Link>
           */}
          </InlineStack>
        </FormLayout>
        <br />
        <Text as="span" tone="subdued">
          {cms("hybrid.dropShip.description")}
        </Text>
      </BlockStack>
      <ConsignmentShip method="hybrid" />
    </HybridDropshipWrapper>
  );
};

export default withErrorBoundary(HybridDropShip);
